<script>
import ListingModel from "@/views/Request/RecruitmentRequest/Components/ListingModel.vue";

export default {
    components: {ListingModel},
};
</script>

<template>
    <ListingModel type="REQUEST" intranet/>
</template>